module.exports = __webpack_public_path__ + "static/media/2.81f6e377.png";